import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import PosTransactionTableFilter from "../Filters/PosTransactionTableFilter";
import { odata } from "../Filters/Helper";
import { ColumnHelper } from "util/TableHelper";
import { useHistory } from "react-router-dom";

import { Table, Empty, Col, Row, Tooltip, message, Button, Modal, Popconfirm ,notification } from "antd";
import { BarsOutlined, FileExcelOutlined, RollbackOutlined, SendOutlined } from "@ant-design/icons";
import config from "../../util/ApiforContext";
import PosEarlyUnblockFrom from "../Forms/PosEarlyUnblockForm";
import { alias } from "odata-query";

const PosTransaction = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const history = useHistory();

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const [tableRolesTenantParameter, setTableRolesTenantParameter] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [unblockData, setUnblockData] = useState({});
  const [isFilterBank, setIsFilterBank] = useState(false);
  const [visibleUnblockModal, setVisibleUnblockModal] = useState(false);
  const [isAvailableEarlyUnblock, setIsAvailableEarlyUnblock] = useState(false);

  const [showFilter, setShowFilter] = useState(true);
  const [isHasInstallmentTransaction, setIsHasInstallmentTransaction] = useState(false);

  useEffect(() => {

    getTenantParameter();
  }, [])

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setIsAvailableEarlyUnblock(response.isPosEarlyUnblockTransaction)
       
      } 
    });
  }
  
  const getFilterQuery = () => {

    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (props.match.params.filter && !filter) {
  
      const [bankId, earlyUnblockId, isEarlyUnblock] = props.match.params.filter.split("&");


      if(isEarlyUnblock == 'true') {
        conditions.push(`posBankId eq ${bankId}`);
        conditions.push(`earlyUnblockId eq ${earlyUnblockId}`)

        setShowFilter(false);
      }
      else {
        const [bankId, installmentCount,onusNotonusId, operationDate] = props.match.params.filter.split("&");

        conditions.push(`posBankId eq ${bankId}`);
        conditions.push(`installmentCount eq ${installmentCount}`);
        conditions.push(`onusNotonusId eq ${onusNotonusId}`);
        conditions.push(odata.dateRange("operationDate", moment(operationDate).startOf("month"), moment(operationDate).endOf("month")));
      }
      
    }

    if(filter.includes("posBankId")) {
      setIsFilterBank(true);
    }
    else {
      setIsFilterBank(false);
    }


    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
    setSelectedRowKeys([]);

    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/PosTransaction?$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });

    RequestHandler.get(`/TenantParameter/GetPosTransactionCardNumber`).then(
      (response) => {
        if (response) {
          setTableRolesTenantParameter(response.data ?? {});
        }
      }
    );
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const renderRowDetail = ({ columns, data }) => {
    return (
      <p>
        {columns.map((column, index) => (
          <p key={index} style={{ marginBottom: ".25em" }}>
            <b>{column.title} : </b>{" "}
            {column.render
              ? column.render(data[column.dataIndex], data, index)
              : data[column.dataIndex]}
          </p>
        ))}
      </p>
    );
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    RequestHandler.post(
      `/PosTransaction/ExportExcel`,
      {
        query: getFilterQuery(),
      },
      false
    ).then((response) => {
      hideMessage();
      if (response.success) {
        if (response) {
          window.open(
            `${config.apiUrl}/PosTransaction/DownloadExcel?fileName=${
              response.message
            }&t=${RequestHandler.getToken()}`
          );
        }
      }else
      notification.error({
        message: response.message,
        duration: 3,
      });
    });
  };

  const tableColumns = [
    {
      title: "POS Banka",
      dataIndex: "posBankLogo",
      width: "120px",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Üye İş Yeri Adı",
      dataIndex: "memberWorkplaceName",
    },
    {
      title: "Üye İş Yeri No",
      dataIndex: "memberWorkplaceNumber",
    },
    {
      title: "Terminal No",
      dataIndex: "terminalNumber",
    },
    {
      title: "Provizyon No",
      dataIndex: "provisionNumber",
    },
    tableRolesTenantParameter.isPosTransactionCardNumberShowInColumn === true
      ? {
          title: "Kart Numarası",
          align: "center",
          dataIndex: "cardNumber",
          key: "cardNumber",
          render: (text) => (text ? text : null),
        }
      : {},
    {
      title: "İşlem Tarihi",
      dataIndex: "operationDate",
      align: "center",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY HH:mm"),
    },
    {
      title: "Valör Tarihi",
      dataIndex: "valueDate",
      align: "center",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    isAvailableEarlyUnblock ?
    {
      title: "Çözüm Tarihi",
      dataIndex: "unblockDate",
      align: "center",
      render: (data, row, index) => {
        if(data !== null) {
          return moment(data).format("DD.MM.YYYY");
        }
    
      } 
    } : {},
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Net Tutar",
      dataIndex: "netAmount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currency",
    },
    {
      title: "Komisyon Tutarı",
      dataIndex: "totalCommissionAmount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Komisyon Oranı(%)",
      dataIndex: "commissionRate",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Taksit Sayısı",
      dataIndex: "installmentCount",
    },
    {
      title: "Taksit Sırası",
      dataIndex: "installmentOrder",
    },
    {
      title: "Gün Sonu Tarihi",
      dataIndex: "endOfDayDate",
      align: "center",
      isRowDetail: true,
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    tableRolesTenantParameter.isPosTransactionCardNumberShowInColumn === false
      ? {
          title: "Kart Numarası",
          dataIndex: "cardNumber",
          isRowDetail: true,
        }
      : {},
    {
      title: "Banka Komisyon Tutarı",
      dataIndex: "bankCommissionAmount",
      isRowDetail: true,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Diğer Komisyon Tutarı",
      dataIndex: "otherCommissionAmount",
      isRowDetail: true,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      isRowDetail: true,
    },
    {
      title: "İşlem Tipi",
      dataIndex: "operationType",
      isRowDetail: true,
    },
    {
      title: "IBAN / Hesap No",
      dataIndex: "returnIban",
      isRowDetail: true,
    },
    {
      title: "Pos Tipi",
      dataIndex: "posType",
      isRowDetail: true,
    },
    {
      title: "Pos Kart Tipi",
      dataIndex: "posCardType",
      isRowDetail: true,
    },
    {
      title: "Batch No",
      dataIndex: "batchNo",
      isRowDetail: true,
    },
    {
      title: "Kart Bankası",
      dataIndex: "cardBankName",
      isRowDetail: true
    },
    {
      title: "Tip",
      dataIndex: "onusNotonusId",
      isRowDetail: true,
      align: "center",
      render: (value) => {
        switch (value) {
          case 1:
            return "Onus";
          case 2:
            return "NotOnus";
          default:
            return "-"; 
        }
      }
    }
  ];


  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);

    
    const selectedRowsData = tableData.data.filter((row) =>
      selectedKeys.includes(row.id)
    );

    if(selectedRowsData.filter(x=> x.installmentCount > 1).length > 0) { 
      setIsHasInstallmentTransaction(true);
    }
    else {
      setIsHasInstallmentTransaction(false);
    }
  };

  const openUnblockModal = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );


    setUnblockData({
      bankId: selectedRowsData[0].posBankId,
      bank: selectedRowsData[0].posBankLogo,
      count: selectedRowsData.length,
      amount: selectedRowsData.reduce((x, y) => x + parseFloat(y.amount), 0),
      netAmount: selectedRowsData.reduce((x, y) => x + parseFloat(y.netAmount), 0),
      transactionIds: selectedRowKeys
    });

    setVisibleUnblockModal(true)
  }

  const onSuccessEarlyUnblock = () => {
    setVisibleUnblockModal(false);

    getTableData();
  }
  return (
    <>
      {props.match.params.filter && (
        <Row style={{ marginBottom: 9 }}>
          <Col flex={1}>
            <a
              onClick={() => history.goBack()}
              style={{ color: "black", marginLeft: "4%" }}
            >
              {" "}
              <RollbackOutlined /> GERİ DÖN
            </a>
          </Col>
          <Col flex={4}></Col>
        </Row>
      )}

      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> POS HAREKETLERİ
          </p>
        </Col>
       
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>

       
          {
             isAvailableEarlyUnblock && showFilter ? 
               !isFilterBank || selectedRowKeys.length < 1 ?
              <Tooltip title={isFilterBank ? "Lütfen bloke kaldırmak istediğiniz hareketleri seçiniz." : "Lütfen banka filtreleyiniz."}>
                <Button
                  type="primary"
                  disabled={!isFilterBank || selectedRowKeys.length < 1}
                  style={{ marginBottom: 10, marginRight: 15}}
                  onClick={openUnblockModal}

                >
                  Bloke Çöz
                </Button>
             </Tooltip>  :  
               isHasInstallmentTransaction ?  <Popconfirm
               title="Seçili işlemlerinizde taksitli işlemler de bulunmaktadır. Taksitli işlemlerinizi son kez kontrol etmek ister misiniz?"
               okText="Evet"
               cancelText="Hayır"
               onCancel={() => openUnblockModal()}
             >

              <Button
                type="primary"
                disabled={!isFilterBank || selectedRowKeys.length < 1}
                style={{ marginBottom: 10}}

              >
                Bloke Çöz
              </Button>
          </Popconfirm> :
               <Button
                type="primary"
                disabled={!isFilterBank || selectedRowKeys.length < 1}
                style={{ marginBottom: 10}}
                onClick={openUnblockModal}

              >
                  Bloke Çöz
                </Button>
           : <></>
          }
       
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      {
        showFilter ?   
        <PosTransactionTableFilter
          filter={props.match.params.filter}
          onClearFilter={onClearTableFilter}
          onFinishFilter={onFinishTableFilter}
          style={{ marginTop: 12, marginBottom: 12 }}
          data = {{isAllowEarlyUnblock:isAvailableEarlyUnblock }}
        /> : <></>
      }
    

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={tableColumns.filter((column) => !column.isRowDetail)}
            expandable={{
              expandedRowRender: (row) =>
                renderRowDetail({
                  data: row,
                  columns: tableColumns.filter((column) => column.isRowDetail),
                }),
            }}
            rowSelection={isAvailableEarlyUnblock && showFilter ? {
        
               selectedRowKeys: selectedRowKeys,
               onChange: onTableSelectChange,
               getCheckboxProps: record => ({
                 disabled: record.isEarlyUnblock || moment().add(-1, "days") >= moment(record.valueDate)             
               }
              ) 
            }: undefined }
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Modal
        centered
        title={"Bloke Çöz"}
        visible={visibleUnblockModal}
        onCancel={() =>
          setVisibleUnblockModal(false)
        }   
        footer={null}
      >
        <PosEarlyUnblockFrom data={unblockData} onSuccess = {onSuccessEarlyUnblock}/>
      </Modal>
    </>
  );
};

export default PosTransaction;
